<div class="modal-header">
  <h2 class="modal-title" id="modal-title">{{ HeaderText | translate }}</h2>
  <button type="button" class="close" aria-describedby="modal-title" (click)="modalClose()">
      <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ MessageText | translate }}</p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-warning" (click)="modalClose()">{{ 'ok' | translate }}</button>
</div>
